import styled from 'styled-components';
import InternationalPlugIconSvg from '../../assets/hotels/amenities/InternationalPlug.svg';

const InternationalPlugIcon = styled(
  InternationalPlugIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default InternationalPlugIcon;
